import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FailureDescription, FailureDialogData } from '../../../go/model/form.model';

@Component({
  selector: 'failure-register-dialog',
  templateUrl: './failure-register-dialog.component.html',
})
export class FailureRegisterDialogComponent {
  @Output() deleteDefectEvent = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FailureDialogData,
    public dialogRef: MatDialogRef<FailureRegisterDialogComponent>,
  ){
  }

  close(event: FailureDescription) {
    this.dialogRef.close(event);
  }
}
